import React, { useEffect, useState } from "react";
import { Card, Col, Row, Statistic, Table, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchSequenceReport } from "../../../redux/actions/sequencesAction";
import { useSequenceDetail } from "./SequenceDetailContext";

const { Text } = Typography;

export default function SequenceReport() {
  const { id, isNew } = useSequenceDetail();
  const dispatch = useDispatch();
  const report = useSelector((state) => state.sequences.report);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isNew) return;
    setLoading(true);
    dispatch(fetchSequenceReport(id))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [dispatch, id, isNew]);

  if (isNew) {
    return <Text type="secondary">Save the sequence first to see its report.</Text>;
  }

  const byStatus = report?.byStatus || {};
  const exitReasons = report?.exitReasons || {};
  const perStep = report?.perStep || [];

  const perStepRows = {};
  for (const row of perStep) {
    const step = row._id.step;
    if (!perStepRows[step]) perStepRows[step] = { step };
    perStepRows[step][row._id.status] = row.count;
  }
  const perStepData = Object.values(perStepRows).sort((a, b) => a.step - b.step);

  return (
    <div>
      <Row gutter={16}>
        <Col span={6}>
          <Card size="small" loading={loading}>
            <Statistic title="Active" value={byStatus.active || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card size="small" loading={loading}>
            <Statistic title="Completed" value={byStatus.completed || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card size="small" loading={loading}>
            <Statistic title="Exited" value={byStatus.exited || 0} />
          </Card>
        </Col>
        <Col span={6}>
          <Card size="small" loading={loading}>
            <Statistic title="Paused (quota)" value={byStatus.paused_quota || 0} />
          </Card>
        </Col>
      </Row>

      <Card size="small" title="Exit reasons" style={{ marginTop: 16 }} loading={loading}>
        {Object.keys(exitReasons).length ? (
          <Table
            size="small"
            rowKey="reason"
            pagination={false}
            dataSource={Object.entries(exitReasons).map(([reason, count]) => ({
              reason,
              count,
            }))}
            columns={[
              { title: "Reason", dataIndex: "reason", key: "reason" },
              { title: "Count", dataIndex: "count", key: "count" },
            ]}
          />
        ) : (
          <Text type="secondary">No exits yet.</Text>
        )}
      </Card>

      <Card size="small" title="Sends per step" style={{ marginTop: 16 }} loading={loading}>
        {perStepData.length ? (
          <Table
            size="small"
            rowKey="step"
            pagination={false}
            dataSource={perStepData}
            columns={[
              {
                title: "Step",
                dataIndex: "step",
                key: "step",
                render: (v) => `Step ${v + 1}`,
              },
              { title: "Sent", dataIndex: "success", key: "success", render: (v) => v || 0 },
              { title: "Failed", dataIndex: "failed", key: "failed", render: (v) => v || 0 },
              { title: "Invalid", dataIndex: "invalid", key: "invalid", render: (v) => v || 0 },
            ]}
          />
        ) : (
          <Text type="secondary">No sends yet.</Text>
        )}
      </Card>
    </div>
  );
}
